import { Alert, Container, Grid, Snackbar, Stack } from "@mui/material";
import ThemeWrapper from "./components/ThemeWrapper";
import Info from "./components/Info";
import EditorHeader from "./components/EditorHeader";
import PreviewWorkspace from "./components/PreviewWorkspace";
import ControlPanel from "./components/ControlPanel";
import ActionBar from "./components/ActionBar";
import useStickerEditor from "./hooks/useStickerEditor";

function getSliderValue(value) {
  return Array.isArray(value) ? value[0] : value;
}

function App() {
  const {
    backgroundColor,
    canvasRef,
    characterIndex,
    closeFeedback,
    closeInfo,
    copy,
    currentCharacter,
    curve,
    dominantColor,
    download,
    draw,
    feedback,
    fontSize,
    handleCurveChange,
    handleHorizontalPositionChange,
    handleVerticalPositionChange,
    infoOpen,
    isCopySupported,
    openInfo,
    position,
    rotate,
    setCharacterIndex,
    setFontSize,
    setRotate,
    setSpaceSize,
    setText,
    spaceSize,
    text,
    verticalSliderValue,
  } = useStickerEditor();

  return (
    <ThemeWrapper
      dominantColor={dominantColor}
      backgroundColor={backgroundColor}
    >
      <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3, md: 4 } }}>
        <Stack spacing={{ xs: 2, sm: 3 }}>
          <EditorHeader accentColor={dominantColor} onInfoOpen={openInfo} />

          <Grid container spacing={{ xs: 2, sm: 3 }}>
            <Grid item xs={12} md={5}>
              <PreviewWorkspace
                canvasRef={canvasRef}
                characterIndex={characterIndex}
                currentCharacter={currentCharacter}
                draw={draw}
                fontSize={fontSize}
                onCharacterChange={setCharacterIndex}
                onHorizontalPositionChange={handleHorizontalPositionChange}
                onVerticalPositionChange={handleVerticalPositionChange}
                position={position}
                verticalSliderValue={verticalSliderValue}
              />
            </Grid>

            <Grid item xs={12} md={7}>
              <Stack spacing={{ xs: 2, sm: 3 }}>
                <ControlPanel
                  curve={curve}
                  fontSize={fontSize}
                  onCurveChange={handleCurveChange}
                  onFontSizeChange={(_, value) => setFontSize(getSliderValue(value))}
                  onRotateChange={(_, value) => setRotate(getSliderValue(value))}
                  onSpaceSizeChange={(_, value) => setSpaceSize(getSliderValue(value))}
                  onTextChange={(event) => setText(event.target.value)}
                  rotate={rotate}
                  spaceSize={spaceSize}
                  text={text}
                />

                <ActionBar
                  isCopySupported={isCopySupported}
                  onCopy={copy}
                  onDownload={download}
                />
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Container>

      <Snackbar
        open={feedback.open}
        autoHideDuration={2600}
        onClose={closeFeedback}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={closeFeedback} severity="success" variant="filled">
          {feedback.message}
        </Alert>
      </Snackbar>

      <Info open={infoOpen} onClose={closeInfo} />
    </ThemeWrapper>
  );
}

export default App;
